import React from 'react'
import { Accordion, ErrorBoundary } from '@sainsburys-tech/bolt'

import CMSComponents, { components, GetComponent } from '@sainsburys-tech/bolt-cms-components'
import { connect } from 'react-redux'
import * as Styled from './Delivery.styles'
import { scrollToAccordion } from '../../../helpers/openAccordion'
import { pushEventAndTrack } from '../../../helpers/taggingSerializer'

const DeliveryAccordion = ({ content }) => {
  const Header = <Styled.Heading>Delivery & returns</Styled.Heading>
  const dataTest = 'delivery-and-returns-accordion'
  const onAccordionInteraction = (index, show) => {
    if (show) {
      scrollToAccordion('#delivery-and-returns-accordion', true)
    }
    // Adobe Analytics Tracking Code
    const adobeAnalytics = show ? pushEventAndTrack : () => {}
    adobeAnalytics({
      eventInfo: {
        eventName: 'pdp_showMore',
        eventAction: 'Delivery and Returns'
      }
    })
  }

  const accordionOptions = {
    title: Header,
    name: 'delivery-and-returns-accordion',
    id: 'delivery-and-returns-accordion',
    'data-test': dataTest,
    index: 'delivery-and-returns-accordion',
    onClick: onAccordionInteraction
  }

  return (
    content && (
      <Accordion.Item as='h3' hasBorderBottom noAnimation {...accordionOptions}>
        <CMSComponents components={components}>
          <ErrorBoundary>
            {content.map((item, index) => {
              return <GetComponent {...item} key={`cms-delivery-accordion-${index}`} />
            })}
          </ErrorBoundary>
        </CMSComponents>
      </Accordion.Item>
    )
  )
}

const mapStateToProps = state => {
  const { cms } = state

  const props = {
    content: cms.mto.delivery || cms.twoManDelivery
  }

  return props
}

export default connect(mapStateToProps)(DeliveryAccordion)
export { DeliveryAccordion }
